<template>
  <v-container
    fluid
    class="fill-height"
  >
    <v-row
      justify="center"
      align="center"
      class="ma-0"
    >
      <polyline-view-card
        v-if="isViewMode"
        :mode.sync="mode"
      >
      </polyline-view-card>
      <polyline-edit-card
        v-else
        :mode.sync="mode"
      >
      </polyline-edit-card>
    </v-row>
  </v-container>
</template>

<script>
  import {FEATURE_CARD_STATE} from "../../../../helpers/geometries/constants"
  import PolylineViewCard from "./PolylineViewCard"
  import PolylineEditCard from "./PolylineEditCard"
  import {ProcessingGeometry} from "../../../../helpers/geometries/models"
  import {isEqual} from "lodash/lang"

  const _PolylineMap = Symbol.for("_PolylineMap")
  const _PolylineLayer = Symbol.for("_PolylineLayer")
  const _PolylineFeature = Symbol.for("_PolylineFeature")

  export default {
    name: "PolylineCardWrapper",
    components: {PolylineEditCard, PolylineViewCard},
    props: {
      feature: {
        type: ProcessingGeometry,
        required: true,
      },
      map: {
        type: Object,
        required: true,
      },
      layer: {
        type: window.L.Polyline,
        required: true,
      },
    },
    data: () => ({
      mode: FEATURE_CARD_STATE.VIEW,
    }),
    provide() {
      return {
        [_PolylineFeature]: () => this.feature,
        [_PolylineLayer]: () => this.layer,
        [_PolylineMap]: () => this.map
      }
    },
    computed: {
      isViewMode() {
        return isEqual(this.mode, FEATURE_CARD_STATE.VIEW)
      },
    },
  }
</script>

<style scoped>
</style>
